/* eslint-disable */
;(function ($) {
	/**
	 * initializeBlock
	 *
	 * Adds custom JavaScript to the block HTML.
	 *
	 * @date    15/4/19
	 * @since   1.0.0
	 *
	 * @param   object $block The block jQuery element.
	 * @param   object attributes The block attributes (only available when editing).
	 * @return  void
	 */
	var initializeBlock = function ($block) {
		$('.university-awards-slider').each(function (index) {
			//var dynamicId = 'dynamic-slider-' + (index + 1)
			var dynamicId = $(this).data('slider-id')
			$(this).attr('id', dynamicId) // Assign the dynamic ID

			// Initialize Slick Slider using the assigned ID or the class
			$('#' + dynamicId).slick({
				slidesToShow: 4,
				slidesToScroll: 1,
				arrows: true,
				prevArrow: $(this).parent().find('.custom-prev-button'),
				nextArrow: $(this).parent().find('.custom-next-button'),
				dots: false,
				autoplay: false,
				responsive: [
					{
						breakpoint: 800,
						settings: {
							slidesToShow: 3,
						},
					},
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 2,
						},
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
						},
					},
				],
			})
		})
	}

	// Initialize each block on page load (front end).
	$(document).ready(function () {
		initializeBlock()
	})

	// Initialize dynamic block preview (editor).
	if (window.acf) {
		window.acf.addAction('render_block_preview', initializeBlock)
	}
})(jQuery)
